import type { ChassisCodeEntry } from "@bt/parts-core";
import type { ChassisCodeColor, ChassisCodeListStyle } from "../chassis-codes";

// How the Zuffenhausen data package's chassis codes are coloured; its list is data in
// @bt/parts-core (data/make-packages/zuffenhausen.json, ADR 0014).

/** Families of similar hues; a variant (Turbo, GT) is coloured like an M car. */
const HUES = {
  "911": ["sky", "blue", "indigo"],
  variant: ["red", "rose"],
  mid: ["emerald", "green"],
  transaxle: ["amber", "yellow"],
  suv: ["violet", "purple"],
  panamera: ["teal", "cyan"],
  classic: ["orange", "lime"],
} as const satisfies Record<string, readonly ChassisCodeColor[]>;

const MID_ENGINE = new Set(["914", "986", "987", "981", "982", "980", "918"]);
const TRANSAXLE = new Set(["924", "928", "944", "968"]);
const SUV = new Set(["955", "957", "958", "9YA", "X1A", "95B", "XAB"]);
const PANAMERA = new Set(["970", "971", "976", "9J1"]);

function series(entry: ChassisCodeEntry): keyof typeof HUES {
  const code = entry.code;
  if (code.includes("(") || code === "930") return "variant";
  if (MID_ENGINE.has(code)) return "mid";
  if (TRANSAXLE.has(code)) return "transaxle";
  if (SUV.has(code)) return "suv";
  if (PANAMERA.has(code)) return "panamera";
  if (/^(901|911 G|9[6-9]\d)$/.test(code)) return "911";
  return "classic";
}

export const ZUFFENHAUSEN_CHASSIS_CODE_STYLES: Record<"porsche", ChassisCodeListStyle> = {
  porsche: { series, hues: HUES },
};
